import EventUtils from './index';

export default class ResizeEvent extends EventUtils {
  static _resizeEvent = null;

  /**
   * 使用事件
   * @param domObj DOM树对象
   * @default window
   * @returns
   */
  static useEvent(domObj = window) {
    if (!this._resizeEvent) {
      this._resizeEvent = new ResizeEvent(domObj);
    } else {
      this._resizeEvent.domObj = domObj;
    }

    return this._resizeEvent;
  }

  /**
   * DOM调整监听
   * @param callBack 回调方法
   */
  resize(callBack) {
    const listener = (event) => {
      if (callBack) {
        callBack.call(this, event.target);
      }
    };

    if (ResizeEvent._resizeEvent) {
      return this.add('resize', listener);
    } else {
      return null;
    }
  }

  /**
   * 获取元素宽度
   * @param elementObj 元素
   * @default document.body
   * @returns 元素宽度
   */
  static getWidth(elementObj = document.body) {
    return elementObj.clientWidth;
  }

  /**
   * 获取元素高度
   * @param elementObj 元素
   * @default document.body
   * @returns 元素高度
   */
  static getHeight(elementObj = document.body) {
    return elementObj.clientHeight;
  }
}
